// extracted by mini-css-extract-plugin
export default {"chipContainer":"Chip__chipContainer___LPEKN","selected":"Chip__selected___eX8_l"};